var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full w-full mx-auto p-6"},[_c('div',{staticClass:"bg-white shadow-lg rounded-lg w-full h-full overflow-hidden"},[_c('gallery-grid',{attrs:{"multimedia":_vm.listGalleryMultimedia,"colorP":_vm.color_principal,"colorS":_vm.color_secundario,"colorT":_vm.color_terciario}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }